import { resourceIdZodSchema } from "@@/shared/acquire/resources/resource-id";
import { iCalImportIdZodSchema } from "@@/shared/channels/ical/ical-import-channel";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import { z } from "zod";

// Edit Command Schema
const iCalImportChannelEditCommandZodObject = z.object({
    _type: z.literal("ICAL_IMPORT_CHANNEL_EDIT_COMMAND"),
    iCalImportId: iCalImportIdZodSchema,
    providerId: providerIdZodSchema,
    targetUrl: z.string(),
    targetResource: resourceIdZodSchema,
});

type ICalImportChannelEditCommand = z.infer<
    typeof iCalImportChannelEditCommandZodObject
>;

const _iCalImportChannelEditCommandFactoryParamsZodObject =
    iCalImportChannelEditCommandZodObject.omit({
        _type: true,
    });

type ICalImportChannelEditCommandFactoryParams = z.infer<
    typeof _iCalImportChannelEditCommandFactoryParamsZodObject
>;

// Edit Command Factory
const iCalImportChannelEditCommandFactory = (
    params: ICalImportChannelEditCommandFactoryParams,
): ICalImportChannelEditCommand => {
    return {
        ...params,
        _type: "ICAL_IMPORT_CHANNEL_EDIT_COMMAND",
    };
};

export {
    iCalImportChannelEditCommandFactory,
    iCalImportChannelEditCommandZodObject,
};

export type {
    ICalImportChannelEditCommand,
    ICalImportChannelEditCommandFactoryParams,
};
